import { render } from "./SustainabilityRecognition.vue?vue&type=template&id=eb7110f2&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__